import styled from "styled-components";

export const StyledStepHeader = styled.div`
  display: flex;
  padding: 12px 12px 12px 32px;
  justify-content: space-between;
`;

export const StyledStepTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledStepHeaderLeft = styled.div`
  display: flex;
`;

export const StyledCustomStep = styled.div`
  overflow-y: auto;
`;
